export const ORDER_ALERTS_ENABLED_KEY = "lusuku:orderAlerts:enabled";
export const ORDER_ALERTS_STATE_EVENT = "lusuku:order-alerts-state";
export const ORDER_ALERTS_CONFIG_EVENT = "lusuku:order-alerts-config";
export const ORDER_ALERTS_CONFIG_VERSION_KEY =
  "lusuku:orderAlerts:configVersion";

export function readOrderAlertsEnabled() {
  try {
    return window.localStorage.getItem(ORDER_ALERTS_ENABLED_KEY) === "true";
  } catch (_error) {
    return false;
  }
}

export function writeOrderAlertsEnabled(enabled) {
  const next = enabled === true;
  try {
    window.localStorage.setItem(ORDER_ALERTS_ENABLED_KEY, next ? "true" : "false");
  } catch (_error) {
    /* The in-memory state still works when storage is unavailable. */
  }

  if (typeof window !== "undefined") {
    window.dispatchEvent(
      new CustomEvent(ORDER_ALERTS_STATE_EVENT, { detail: { enabled: next } })
    );
  }
}

export function announceOrderAlertsConfigChanged() {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(
      ORDER_ALERTS_CONFIG_VERSION_KEY,
      String(Date.now())
    );
  } catch (_error) {
    /* The in-page event still refreshes mounted alert engines. */
  }
  window.dispatchEvent(new CustomEvent(ORDER_ALERTS_CONFIG_EVENT));
}

export function readOrderAlertsConfigVersion() {
  try {
    return window.localStorage.getItem(ORDER_ALERTS_CONFIG_VERSION_KEY) || "";
  } catch (_error) {
    return "";
  }
}
